import { forwardRef, type SVGProps } from 'react'

interface SponsorshipsIconProps extends SVGProps<SVGSVGElement> {}

export const SponsorshipsIcon = forwardRef<
  SVGSVGElement,
  SponsorshipsIconProps
>((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      width="24px"
      viewBox="0 0 23.537 25.322"
      fill="currentColor"
      {...props}
    >
      <g data-name="Grupo 1815">
        <path
          data-name="Caminho 1438"
          d="M19.777 6.857L12.763.24a.89.89 0 00-.609-.24H2a2 2 0 00-2 1.982V23.04a2 2 0 002 1.982h8.9a.856.856 0 100-1.711H2a.3.3 0 01-.274-.271V1.982A.291.291 0 012 1.711h9.3v5.773a.846.846 0 00.857.857h6.182a.918.918 0 00.835.591.873.873 0 00.884-.861v-.586a.87.87 0 00-.278-.627zm-6.749-3.964l3.948 3.737h-3.948z"
          transform="translate(-1.211 .15) translate(1.361)"
          fill="currentColor"
        />
        <path
          data-name="Caminho 1438 - Contorno"
          d="M2-.15h10.15a1.046 1.046 0 01.712.281l7.018 6.617a1.021 1.021 0 01.325.736v.586a1.024 1.024 0 01-1.034 1.011 1.063 1.063 0 01-.934-.591h-6.082a1 1 0 01-1.007-1.007V1.861H2a.143.143 0 00-.124.121V23.04a.148.148 0 00.124.121h8.9a1.006 1.006 0 110 2.011H2A2.145 2.145 0 01-.15 23.04V1.982A2.145 2.145 0 012-.15zm17.172 8.931a.724.724 0 00.734-.711v-.585a.72.72 0 00-.231-.518L12.66.349a.743.743 0 00-.506-.2H2A1.845 1.845 0 00.15 1.982V23.04A1.845 1.845 0 002 24.871h8.9a.706.706 0 100-1.411H2a.445.445 0 01-.424-.421V1.982A.439.439 0 012 1.561h9.444v5.923a.7.7 0 00.707.707h6.286l.036.1a.769.769 0 00.699.49zm-6.294-6.236l4.475 4.235h-4.475zM16.6 6.48l-3.422-3.238V6.48z"
          transform="translate(-1.211 .15) translate(1.361)"
          fill="currentColor"
        />
        <g data-name="Grupo 1732">
          <g data-name="Grupo 1730">
            <path
              data-name="Caminho 1439"
              d="M197.526 204.9a7.459 7.459 0 117.457-7.459 7.467 7.467 0 01-7.457 7.459zm0-13.178a5.719 5.719 0 105.717 5.719 5.724 5.724 0 00-5.717-5.72z"
              transform="translate(-1.211 .15) translate(9.847 9.842) translate(-.014 -.739) translate(-190.069 -189.98)"
              fill="currentColor"
            />
          </g>
          <g data-name="Grupo 1731">
            <path
              data-name="Caminho 1440"
              d="M289.57 250.094c-.786-.326-.919-.487-.919-.725 0-.277.232-.442.621-.444a2.735 2.735 0 011.328.471l.473-1.251a3.105 3.105 0 00-1.263-.487v-.915h-1.25v.991a1.781 1.781 0 00-1.376 1.744c0 1.074.826 1.547 1.717 1.9.718.292.817.543.817.77 0 .335-.29.552-.739.553a2.684 2.684 0 01-1.487-.587l-.455 1.273a2.982 2.982 0 001.46.6v.945h1.257v-1.019a1.89 1.89 0 001.44-1.826c0-.928-.486-1.523-1.624-1.988z"
              transform="translate(-1.211 .15) translate(9.847 9.842) translate(5.495 3.498) translate(-287.036 -247.743)"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </svg>
  )
})

SponsorshipsIcon.displayName = 'SponsorshipsIcon'
